import { useState } from 'react'

import { UPLOAD_IMAGE_CROP_SHAPE } from '../../UploadImage'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, radioGroup, text } from '../Controls'

import { UploadImageDemo } from './UploadImageDemo'
import {
  CROP_SHAPE_OPTIONS,
  PREVIEW_INTERACTIVE,
  PREVIEW_STATE_OPTIONS,
  UPLOAD_MODE,
  UPLOAD_MODE_OPTIONS,
} from './UploadImageUsage.constants'

export function UploadImageUsage() {
  const [props, setProps] = useState(() =>
    controls()
      .add(
        radioGroup('cropShape', UPLOAD_IMAGE_CROP_SHAPE.CIRCLE, {
          options: CROP_SHAPE_OPTIONS,
        })
      )
      .add(
        radioGroup('uploadMode', UPLOAD_MODE.REAL, {
          options: UPLOAD_MODE_OPTIONS,
        })
      )
      .add(
        radioGroup('previewState', PREVIEW_INTERACTIVE, {
          options: PREVIEW_STATE_OPTIONS,
        })
      )
      .add(text('titleKey', 'UploadImage.ChangePhotoTitleKey'))
      .add(text('initialImageUrl'))
      .add(text('documentType'))
      .add(text('parent'))
      .add(boolean('withRotate', true))
      .add(boolean('withUndo', true))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={UploadImageDemo}
        name='UploadImageModal'
      />
      <ComponentProps
        name='UploadImageModal'
        value={props}
        onChange={setProps}
      />
    </>
  )
}
